/*
  +--------------------------------------------------------------------------------------
  | @Author:    young<yangyang@frippler.com>
  | @Title:     账户管理-企业信息 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function getGodInfoApi() {
  return request({
    url: '?c=fam&a=god&do=get',
    method: 'get'
  })
}

export function postGodInfoApi(data) {
  return request({
    url: '?c=fam&a=god&do=post',
    method: 'post',
    data: data
  })
}

export function godCertifyApi(data) {
  return request({
    url: '?c=fam&a=god&do=certify',
    method: 'post',
    data: data
  })
}

export function getGodSettingApi(query) {
  return request({
    url: `${ jsApiHost }/god/get`,
    method: 'get',
    params: query
  })
}

export function postGodSettingApi(data) {
  return request({
    url: `${ jsApiHost }/god/post`,
    method: 'post',
    data: data
  })
}

export function getResourceListApi(query) {
  return request({
    url: `${ jsApiHost }/god/resource/list`,
    method: 'get',
    params: query
  })
}

export function resourcePreUploadApi(query) {
  return request({
    url: `${ jsApiHost }/god/resource/preUpload`,
    method: 'get',
    params: query
  })
}

export function resourceUploadFinishApi(data) {
  return request({
    url: `${ jsApiHost }/god/resource/uploadFinish`,
    method: 'post',
    data: data
  })
}

export function resourceUpdateApi(data) {
  return request({
    url: `${ jsApiHost }/god/resource/update`,
    method: 'post',
    data: data
  })
}

export function resourceDeleteApi(data) {
  return request({
    url: `${ jsApiHost }/god/resource/delete`,
    method: 'post',
    data: data
  })
}